<div class="col-sm-6">
  <p-button routerLink="/admin/project" severity="primary" label="Back to projects"></p-button>
</div>


<div class="card bg-light card-header">
  <div class="row">
    <div class="col-sm-9">
      <h4>
        Project <strong>{{ project.id }}</strong>
      </h4>
    </div>
    <div class="col-sm-3" >
      <app-my-delete-confirm [onConfirm]="delete_project"></app-my-delete-confirm>
    </div>
  </div>
</div>


<div class="card bg-light">
  <div class="card-header">Update project</div>
  <div class="card-body">
    @if (prj_err_msg) {
      <div class="alert alert-danger">{{ prj_err_msg }}</div>
    }
    @if (prj_msg) {
      <div class="alert alert-info">{{ prj_msg }}</div>
    }
    <form aria-label="project edition form" role="form" class="user-form form-horizontal form-register">
      <div class="form-group row">
        <div class="col-sm-2">
          <label for="update_project_owner">Owner</label>
          <select id="update_project_owner" [ngModelOptions]="{ standalone: true }" [(ngModel)]="project.owner" class="form-control">
            @for (user_o of users; track user_o) {
              <option [ngValue]="user_o.uid">{{ user_o.uid }}</option>
            }
          </select>
        </div>
        @if (!config.project || config.project.enable_group) {
          <div class="col-sm-2">
            <label for="update_project_group">Group</label>
            <select id="update_project_group" [ngModelOptions]="{ standalone: true }" [(ngModel)]="project.group" class="form-control">
              @for (group of groups; track group) {
                <option [ngValue]="group.name">{{ group.name }}</option>
              }
            </select>
          </div>
        }
        <div class="col-sm-2">
          <label for="update_project_size">Size (GB)</label>
          <input id="update_project_size" type="text" [ngModelOptions]="{ standalone: true }" [(ngModel)]="project.size" class="form-control" />
        </div>
        <div class="col-sm-2">
          <label for="update_project_cpu">Cpu (Hour)</label>
          <input id="update_project_cpu" type="text" [ngModelOptions]="{ standalone: true }" [(ngModel)]="project.cpu" class="form-control" />
        </div>
        <div class="col-sm-2">
          <label for="project_date">Creation date</label>
          <input type="date" id="project_date" value="{{ date_convert(project.created_at) }}" class="form-control" readonly />
        </div>
        <div class="col-sm-2">
          <label for="update_project_exp">Expiration date</label>
          <input type="date" id="update_project_exp" [ngModelOptions]="{ standalone: true }" [(ngModel)]="project_expire" class="form-control" />
        </div>
        <div class="col-sm-2">
          <label>Financing</label>
          <input type="text" id="update_project_orga" [ngModelOptions]="{ standalone: true }" [(ngModel)]="project.orga" class="form-control" />
        </div>
      </div>
      <div class="form-group row">
        <div class="col-sm-12">
          <label for="project_description">Description</label>
          <textarea rows="2" id="project_description" [ngModelOptions]="{ standalone: true }" [(ngModel)]="project.description" class="form-control"></textarea>
        </div>
      </div>
      <div class="form-group row">
        @if (!config.project || config.project.enable_group) {
          <div class="col-sm-2">
            <label>Write permission&nbsp;
              <span class="glyphicon glyphicon-question-sign" data-html="true" title="Write access<br>Group : all members<br>Data manager : owner" tooltip> </span>
            </label>
            <select id="project_access" [ngModelOptions]="{ standalone: true }" [(ngModel)]="project.access" class="form-control">
              <option value="Group">Group</option>
              <option value="Data manager">Data manager</option>
            </select>
          </div>
        }
        <div class="col-sm-3">
          <label for="update_project_path">Path to project</label>
          <input type="text" id="update_project_path" [ngModelOptions]="{ standalone: true }" [(ngModel)]="project.path" class="form-control" />
        </div>
      </div>

      <div class="form-group row">
        <div class="col-sm-2">
          <label style="opacity: 0">Update project</label>
          <p-button type="button" size="small" severity="success" (onClick)="update_project()" label="Update project"></p-button>
        </div>
      </div>
    </form>
  </div>
</div>


<div class="card bg-light">
  <div class="card-header">User management</div>
  <div class="card-body">
    <form role="form" class="user-form form-horizontal form-register">
      <div class="form-group row">
        <div class="col-sm-3">
          <label for="new_manager">New project manager</label>
          <select id="add_manager"  [ngModelOptions]="{standalone: true}" [(ngModel)]="new_manager" class="form-control">
            @for (user of users; track user) {
              <option [value]="user.uid">{{user.uid}}</option>
            }
          </select>
        </div>
        <div class="col-sm-3">
          <label style="opacity: 0;">Add new manager</label>
          <p-button severity="success" size="small" type="button" (onClick)="add_manager(new_manager)" label="Promote to Manager"></p-button>
        </div>
        <div class="col-sm-3">
          <label for="rm_manager">Remove project manager</label>
          <select id="rm_manager"  [ngModelOptions]="{standalone: true}" [(ngModel)]="rm_manager" class="form-control">
            @for (manager of this.project.managers; track manager) {
              <option [value]="manager">{{manager}}</option>
            }
          </select>
        </div>
        <div class="col-sm-3">
          <label style="opacity: 0;">Remove manager</label>
          <p-button severity="warn" size="small" type="button" (onClick)="remove_manager(rm_manager)" label="Demote to Member"></p-button>
        </div>
      </div>
      @if (admin_user_msg) {
        <div class="alert alert-success">{{ admin_user_msg }}</div>
      }
      @if (admin_user_err_msg) {
        <div class="alert alert-danger">{{ admin_user_err_msg }}</div>
      }
      <div class="form-group row">
        <div class="col-sm-3">
          <label for="new_user_admin">New project member</label>
          <select id="new_user_admin" [ngModelOptions]="{ standalone: true }" [(ngModel)]="new_user_admin" class="form-control">
            @for (user_a of all_users; track user_a) {
              <option [ngValue]="user_a.uid">{{ user_a.uid }}</option>
            }
          </select>
        </div>
        <div class="col-sm-2">
          <label style="opacity: 0">Add member</label>
          <p-button severity="success" size="small" type="button" (onClick)="add_user()" label="Add member"></p-button>
        </div>
        <div class="col-sm-1"></div>
        <div class="col-sm-3">
          <label for="remove_user_admin">Remove project member</label>
          <select id="remove_user_admin" [ngModelOptions]="{ standalone: true }" [(ngModel)]="remove_user_admin" class="form-control">
            @for (user_r of users; track user_r) {
              <option [ngValue]="user_r.uid">{{ user_r.uid }}</option>
            }
          </select>
        </div>
        <div class="col-sm-3">
          <label style="opacity: 0">Remove member</label>
          <p-button severity="warn" size="small" type="button" (onClick)="remove_user()" label="Remove member"></p-button>
        </div>
      </div>
    </form>

    <div class="table-responsive table-striped">
      <p-table #dtp [value]="users" [paginator]="true" [rows]="10" [showCurrentPageReport]="true" [rowsPerPageOptions]="[10, 25, 50]">
        <ng-template pTemplate="header">
          <tr>
            <th>User</th>
            <th>Email</th>
            <th>Access</th>
            <th>Manager</th>
            <th>Owner</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-user_l>
          <tr>
            <td>
              <a routerLink="/user/{{ user_l.uid }}">
                <span class="p-button p-button-sm p-button-primary">{{ user_l.uid }}</span>
              </a>
            </td>
            <td>{{ user_l.email }}</td>
            <td>@if (user_l.temp?.access) {
              <span>x</span>
            }</td>
            <td>@if (project.managers.includes(user_l.uid)) {
              <span>x</span>
            }</td>
            <td>@if (user_l.uid === project.owner) {
              <span>x</span>
            }</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
